<template>
  <div class="announcement" ref="container">
    <div class="nav acea-row">
      <div
        class="item"
        :class="types === 1 ? 'on' : ''"
        @click="changeTypes(1)"
      >
        企业
      </div>
      <div
        class="item"
        :class="types === 2 ? 'on' : ''"
        @click="changeTypes(2)"
      >
        系统
      </div>
    </div>
    <div class="annou-record">
      <div class="list" v-if="list.length > 0">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="data acea-row">
            <div class="fuhao">
              <div class="iconfont icon-gonggao font-color-red"></div>
            </div>
            <router-link class="cont" :to="'/anntDetail/' + item.unique">{{
              item.titile
            }}</router-link>
            <div class="mark">
              <span class="weidu font-color-red" v-if="item.readFlag === 0"
                >未读</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="list" v-else>
        <div class="noMessage">
          <div class="iconfont icon-meiyouxiaoxi acea-row row-center"></div>
          <div class="msg acea-row row-center">没有公告</div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import { getAnnouncements } from "@api/announcement";
import Loading from "@components/Loading";
export default {
  name: "CorpAnnouncement",
  data: function() {
    return {
      types: 1,
      where: {
        page: 0,
        size: 10,
        sort: "a.create_time,a.id,desc",
        isF: 0,
        announcementType: 1
      },
      list: [],
      loaded: false,
      loading: false,
      count: 0
    };
  },
  mounted() {
    let that = this;
    that.getAnnouncementList();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getAnnouncementList();
    });
  },
  watch: {
    types: function() {
      this.getAnnouncementList();
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changeTypes: function(val) {
      if (val !== this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 0;
        this.where.announcementType = val;
        this.loaded = false;
        this.loading = false;
      }
    },
    getAnnouncementList() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      that.where.isF = that.count;
      getAnnouncements(that.where)
        .then(res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.size;
          that.where.page = that.where.page + 1;
          that.list = res.data;
          that.count++;
        })
        .catch(err => {
          that.$dialog.message(err.msg);
        });
    }
  }
};
</script>

<style>
.conent {
  width: 100%;
}
.xiaolian {
  width: 6.4rem;
  text-align: center;
  margin: 0 auto;
  margin-top: 50%;
}
.icon-xiaolian {
  font-size: 1.6rem;
  color: #f33c2b;
}
.claims-explain {
  width: 6.4rem;
  text-align: center;
  font-size: 0.5rem;
  color: #000000;
  margin: 0 auto;
}
.goback {
  width: 6.4rem;
  text-align: center;
  font-size: 0.4rem;
  margin: 0.5rem auto 0 auto;
  color: #00aaea;
}
</style>
